import { Injectable } from '@angular/core';
import { CanActivate, CanActivateChild, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';

import { Store, select } from '@ngrx/store';

import * as selectors from '@shared/state/selectors';
import * as Services from '@shared/core/services';

import { Observable, of } from 'rxjs';
import { filter, map, switchMap, take } from 'rxjs/operators';

@Injectable({
    providedIn: 'root',
})
export class ConfirmationGuard implements CanActivate, CanActivateChild {
    constructor(private _onlineOrdersService: Services.OnlineOrdersService, private _routeService: Services.RouteService, private _store: Store<OLO.State>) {}

    public canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> | boolean {
        const queryParamsOrder = route.queryParams?.order;
        const isLiveViewType = route.data?.isLiveViewType;

        return this._routeService.extractOrderConfirmationOrderGUID$().pipe(
            take(1),
            switchMap((queryParams) => {
                if (!queryParams?.orderGUID || isLiveViewType == null || !queryParamsOrder) {
                    console.warn('unable to extract orderGUID or something is wrong with liveview', { queryParams, isLiveViewType });

                    this._routeService.navigate(['/404']);

                    return of(false);
                }

                this._onlineOrdersService.requestHistoryOrder(queryParams.orderGUID);

                return this._store.pipe(
                    select(selectors.getHistoryOrdersState),
                    map((historyOrders) => historyOrders?.orders?.find((order) => order.orderGUID === queryParams.orderGUID)),
                    filter((order) => order && order.isDownloading === false),
                    take(1),
                    map((order) => {
                        if (order.hasFailed) {
                            this._routeService.navigate(['/404']);

                            return false;
                        }

                        return true;
                    }),
                );
            }),
        );
    }

    public canActivateChild(next: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {
        return this.canActivate(next, state);
    }
}
